import { useNavigate } from "react-router-dom";

import { useAuthStore } from "../../auth/store";
import { logoutUser } from "./api";

// Общее действие «выйти»: было приватной `handleLogout` в `AppLayout`,
// вынесено сюда — `SelectOrgPage` (экран нулевого состояния, 0
// организаций) тоже нуждается в выходе, а `AppLayout` там не
// смонтирован (`/select-org` вне layout-route). Поведение бит-в-бит
// прежнее: сначала локальная очистка store (чтобы `ProtectedRoute`
// сразу знал, что user'а нет), затем best-effort POST на backend и
// redirect на `/login`.
export function useLogoutAction(): () => void {
  const navigate = useNavigate();
  return (): void => {
    useAuthStore.getState().logout();
    void logoutUser();
    void navigate("/login", { replace: true });
  };
}
